import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { emptyArray } from 'ui-components/default-props/empty';

import { getUserFriendlyMessagesForErrorResponse } from '../../../errors/user-friendly-error-message-service';

export const WalletErrorBanner = ({ errors = emptyArray, className = '' }) => {
  if (!errors.length) {
    return null;
  }

  const detailedErrors = errors.filter((error) => {
    // NOTE: this is a short term way to address unformed errors we get back from stamps.
    // The long term solution is to serialize the fault exception they send and turn that into an actionable error code.
    const innerErrorContext = error?.ErrorContext?.innerError?.metaData;
    return innerErrorContext?.Message || innerErrorContext?.message;
  });

  const potentialUserFriendlyErrors = errors.filter((error) => !detailedErrors.includes(error));
  const userFriendlyErrors = getUserFriendlyMessagesForErrorResponse({
    Errors: potentialUserFriendlyErrors,
  });
  if (!userFriendlyErrors.errors.length && !detailedErrors.length) {
    return null;
  }

  return (
    <BannerMessageV2
      className={className}
      content={
        <ul>
          {detailedErrors.map((error, index) => {
            const innerErrorContext = error?.ErrorContext?.innerError?.metaData;
            const message = innerErrorContext?.Message || innerErrorContext?.message;
            return <li key={`detailErrors-${index}`}>{message}</li>;
          })}
          {userFriendlyErrors.errors.map((error, index) => {
            return (
              <li key={`formPostError-${index}`}>
                <FormattedMessage {...error.messageDescriptor} values={error.values} />
              </li>
            );
          })}
        </ul>
      }
      status={BannerStatus.Error}
    />
  );
};

WalletErrorBanner.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.object),
  className: PropTypes.string,
};
